(function () {
	const initCollapsibleContent = () => {
		const $items = $(".collapsible-content__item");
		const $toggles = $(".collapsible-content__toggle");
		const $answers = $(".collapsible-content__answer");
		$items.removeClass("active");
		$answers.hide();

		const $firstItem = $items.first();
		$firstItem.addClass("active");
		$firstItem.find(".collapsible-content__answer").show();
		$toggles.each(function () {
			const $toggle = $(this);
			if ($toggle.hasClass("content_started")) return;

			$toggle.addClass("content_started");

			$toggle.on("click", function () {
				const $parent = $toggle.parent();

				if (!$parent.hasClass("active")) {
					$parent
						.siblings(".collapsible-content__item.active")
						.removeClass("active")
						.find(".collapsible-content__answer")
						.stop()
						.slideUp(300);

					$parent.addClass("active");
					$toggle.next(".collapsible-content__answer").stop().slideDown(300);
				} else {
					$parent.removeClass("active");
					$toggle.next(".collapsible-content__answer").stop().slideUp(300);
				}
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
